import React from "react";
import './search-bar.css';
import { getImageUrl } from "../../utils/image-helper/get-image-url";
import { Input } from "antd";

type SearchBarProps = {
    value: string;
    onChange: (value: string) => void;
    icon?: string;
    placeholder?: string;
};

export const SearchBar = ({ onChange, value, placeholder, icon }: SearchBarProps) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange(e.target.value);
    };

    return (
        <Input
            className='search-bar'
            value={value}
            onChange={handleChange}
            placeholder={placeholder ?? 'Keresés'}
            suffix={icon ? <img className='search-bar-icon' src={icon} alt="search-icon" /> : <img className='search-bar-icon' src={getImageUrl('search-icon.png')} alt="search-icon" />}
        />
    );
};